<template>
  <div class="d-flex-1-column">
    <div class="full">
      <div class="home-left">
        <TabularOverviewWrapper :ViewName="viewType.APM" capability="A" />
      </div>
      <div class="home-right">
        <TabularOverviewWrapper :ViewName="viewType.BM" capability="B" />
      </div>
    </div>
    <div class="full">
      <div class="home-left">
        <TabularOverviewWrapper :ViewName="viewType.MM" capability="M" />
      </div>

      <div class="home-right">
        <TabularOverviewWrapper :ViewName="viewType.VM" capability="V" />
      </div>
    </div>
  </div>
</template>
<script>
import BrowserOverview from '@/components/Home/BrowserOverview.vue';
import RecentAlertsOverview from './RecentAlertsOverview.vue';
import EndpointOverview from './EndpointOverview.vue';
import TabularOverviewWrapper from '@/components/Home/TabularOverviewWrapper';
import { OverviewTableName } from '@/components/Home/utils/constants';

export default {
  name: 'HomeDetail',
  components: {
    BrowserOverview,
    RecentAlertsOverview,
    EndpointOverview,
    TabularOverviewWrapper,
  },
  data() {
    return {
      /**
       * type of view
       */
      viewType: OverviewTableName,
    };
  },
};
</script>
<style lang="scss" scoped>
.full {
  margin-top: 1em;
  display: flex;
  flex: 1;
  // margin-right: 0.5625em;
  .home-left {
    margin-right: 1.5625em;
    width: 50%;
  }
  :deep(.rex-service-sel) {
    background: $bg-secondary !important;
  }
  :deep(.items) {
    background: $bg-secondary !important;
  }
  .home-right {
    width: 50%;
    .card {
      width: 100%;
      margin-bottom: 1.25em;
      border-radius: 0.625em;
      @include dropshadow-effect;
      border-radius: 1.0625em;
    }
  }
}
</style>
